var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import { AvatarPlaceholder } from "../../Icons/AvatarPlaceholder";
var getVariantStyle = function (variant) {
    if (variant === "secondary") {
        return secondaryStyle;
    }
    if (variant === "readonly") {
        return readonlyStyle;
    }
    return primaryStyle;
};
export var getSize = function (size) {
    var SIZE_TO_PIXELS = {
        small: 20,
        medium: 30,
        large: 36
    };
    return SIZE_TO_PIXELS[size] || SIZE_TO_PIXELS["medium"];
};
export var StyledImage = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 2px;\n  box-sizing: border-box;\n  height: ", "px;\n  line-height: ", "px;\n  width: ", "px;\n"], ["\n  border-radius: 2px;\n  box-sizing: border-box;\n  height: ", "px;\n  line-height: ", "px;\n  width: ", "px;\n"])), function (_a) {
    var size = _a.size;
    return getSize(size);
}, function (_a) {
    var size = _a.size;
    return getSize(size);
}, function (_a) {
    var size = _a.size;
    return getSize(size);
});
var primaryStyle = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: #fff;\n  border: 1px solid #677a90;\n  color: #007298;\n"], ["\n  background: #fff;\n  border: 1px solid #677a90;\n  color: #007298;\n"])));
var secondaryStyle = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background: #007298;\n  border: 1px solid #e6e6e6;\n  color: #fff;\n"], ["\n  background: #007298;\n  border: 1px solid #e6e6e6;\n  color: #fff;\n"])));
var readonlyStyle = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background: #dee2e6;\n  border: 1px solid #677a90;\n  color: #677a90;\n"], ["\n  background: #dee2e6;\n  border: 1px solid #677a90;\n  color: #677a90;\n"])));
export var StyledAvatarIcon = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  align-items: center;\n  border-radius: 2px;\n  box-sizing: border-box;\n  display: flex;\n  font-size: 22px;\n  font-family: Proxima Nova;\n  font-weight: 700;\n  height: ", "px;\n  justify-content: center;\n  line-height: ", "px;\n  margin: 0;\n  text-align: center;\n  text-transform: uppercase;\n  width: ", "px;\n\n  ", "\n"], ["\n  align-items: center;\n  border-radius: 2px;\n  box-sizing: border-box;\n  display: flex;\n  font-size: 22px;\n  font-family: Proxima Nova;\n  font-weight: 700;\n  height: ", "px;\n  justify-content: center;\n  line-height: ", "px;\n  margin: 0;\n  text-align: center;\n  text-transform: uppercase;\n  width: ", "px;\n\n  ", "\n"])), function (_a) {
    var size = _a.size;
    return getSize(size);
}, function (_a) {
    var size = _a.size;
    return getSize(size);
}, function (_a) {
    var size = _a.size;
    return getSize(size);
}, function (_a) {
    var variant = _a.variant;
    return getVariantStyle(variant);
});
export var StyledAvatarPlaceholder = styled(AvatarPlaceholder)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background: #efefef;\n  border-radius: 2px;\n  border: 1px solid #e6e6e6;\n  box-sizing: border-box;\n  fill: #d9d9d9;\n  height: ", "px;\n  line-height: ", "px;\n  width: ", "px;\n"], ["\n  background: #efefef;\n  border-radius: 2px;\n  border: 1px solid #e6e6e6;\n  box-sizing: border-box;\n  fill: #d9d9d9;\n  height: ", "px;\n  line-height: ", "px;\n  width: ", "px;\n"])), function (_a) {
    var size = _a.size;
    return getSize(size);
}, function (_a) {
    var size = _a.size;
    return getSize(size);
}, function (_a) {
    var size = _a.size;
    return getSize(size);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=styled.js.map